// extracted by mini-css-extract-plugin
export default {"search-logo":"SearchIcon_search-logo__7P0nQ"};